import styled from "styled-components/macro";

export const Page = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: start;
`;
